import { NextSeo } from "next-seo";

import { SITE_ORIGIN } from "~landing/seo/constants";

/**
 * Self-consistent SEO for a static marketing page: emits a per-page `canonical`
 * and a matching `openGraph` (title/description/url) so the page no longer
 * inherits the site-wide homepage `canonical`/`og:url` from `DefaultSeo`.
 *
 * `description` is optional — pages that set no description (e.g. Contact) fall
 * back to the `DefaultSeo` description, same as before. `og:image` is left to
 * `DefaultSeo` (this component emits no `images`, so the site-wide default
 * survives next-seo's per-key dedup).
 */
export function MarketingSeo({
	title,
	description,
	path,
}: {
	title: string;
	description?: string;
	/** Route path with leading slash, e.g. `/pricing`; `""` for the homepage. */
	path: string;
}) {
	const url = `${SITE_ORIGIN}${path}`;

	return (
		<NextSeo
			title={title}
			{...(description ? { description } : {})}
			canonical={url}
			openGraph={{
				title,
				...(description ? { description } : {}),
				url,
				type: "website",
			}}
		/>
	);
}
